/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { INutritionIP } from 'app/shared/model/nutrition-ip.model';
import { INutritionOrder } from 'app/shared/model/nutrition-order.model';

export interface INutritionOrderItem {
  id?: string;
  active?: boolean;
  cursor?: number;
  lastupdated?: number;
  microSec?: number;
  total?: number | null;
  rdi?: boolean | null;
  dailyTotal?: number | null;
  nutrition?: INutritionIP;
  order?: INutritionOrder;
}

export const defaultValue: Readonly<INutritionOrderItem> = {
  active: false,
  rdi: false,
};
